import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { getFreightModeIcon } from "helpers/freightModeHelper";
import testIds from "constants/testIds";
import "./FreightModeButton.scss";

interface FreightModeButtonProps {
  isSelected?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  value: string;
  label?: string;
  type?: string;
  /** Stable freight mode key used for data-testid (e.g. nfo, regular_air). */
  modeValue?: string;
  testId?: string;
}

const toFreightModeTestId = (modeValue: string) =>
  `${testIds.FREIGHT_MODE_BUTTON_PREFIX}${modeValue.toLowerCase().replace(/\s+/g, "_")}`;

export default function FreightModeButton({
  isSelected = false,
  onClick,
  value,
  label,
  type = "",
  modeValue,
  testId,
}: FreightModeButtonProps) {
  const Icon = getFreightModeIcon(value, type, !isSelected);
  const resolvedTestId = testId ?? (modeValue ? toFreightModeTestId(modeValue) : undefined);

  return (
    <OverlayTrigger
      placement="top"
      key={value}
      overlay={
        <Tooltip id="freight-mode" style={{ zIndex: 999999 }}>
          <span className="font-weight-normal">{label ?? value}</span>
        </Tooltip>
      }
    >
      <button
        type="button"
        className={`freight-mode-item ${isSelected ? "active" : ""}`}
        onClick={onClick}
        data-testid={resolvedTestId}
      >
        {Icon && <Icon />}
      </button>
    </OverlayTrigger>
  );
}
